<template>
  <v-container fluid grid-list-xl>
    <v-row dense class="mb-n10" align="center">
      <v-col cols="12" md="6">
        <PayPeriodSelector
        selectPeriod
        entireFiscalYearSelectable
        @period-selected="periodSelected">
        <template #append>
          <v-col>
            <v-select
            class="ml-5"
            v-model="selectedTractType"
            :items="availableTractTypes"
            item-text="tractTypeName"
            :label="$t('tractType')"
            return-object/>
          </v-col>
        </template>
        </PayPeriodSelector>
      </v-col>
    </v-row>
    <v-row v-if="balanceSummaries.length === 0">
      <v-col>
        <NoData>
          {{ $t('noDataForSelection') }}
        </NoData>
      </v-col>
    </v-row>
    <v-row v-else class="mt-7">
      <v-col>
        <DataTable
        :items="filteredSummaries"
        :headers="headers"
        :showSearch="false">
          <template #body.append>
            <tr class="font-weight-bold">
              <td class="text-left">{{ $t('total') }}</td>
              <td class="text-left"></td>
              <td class="text-right">{{ formatMoney(total) }}</td>
              <td class="text-right">{{ formatMoney(remainingBalance) }}</td>
              <td class="text-right">{{ tractTotal }}</td>
              <td class="text-right"></td>
            </tr>
          </template>
        </DataTable>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formatMoney } from '@/utils/NumericMutations.js'
import { utcToLocalDate } from '@/utils/DateFormatter.js'
import { mapActions } from 'vuex'
import TractHeaders from '@/headers/Tract.js'
export default {
  name: 'Obligation',

  components: {
    PayPeriodSelector: () => import('@/components/settlements/PayPeriodSelector.vue'),
    DataTable: () => import('@/components/core/table/DataTable.vue'),
    NoData: () => import('@/components/core/NoData.vue')
  },

  data: () => ({
    selectedPeriod: undefined,
    balanceSummaries: [],
    selectedTractType: undefined
  }),

  computed: {
    filteredSummaries () {
      return this.selectedTractType?.tractTypeId !== undefined
        ? this.balanceSummaries.filter(s => s.tractTypeId === this.selectedTractType?.tractTypeId)
        : this.balanceSummaries
    },

    headers () {
      return TractHeaders.liveObligationHeaders({ isPeriod: this.isPeriod }).columns
    },

    isPeriod () {
      return this.selectedPeriod?.payPeriodId !== undefined
    },

    remainingBalance () {
      return this.filteredSummaries.reduce((acc, cur) => acc + cur.remaining, 0)
    },

    tractTotal () {
      return this.filteredSummaries.reduce((acc, cur) => acc + cur.tractCount, 0)
    },

    total () {
      return this.filteredSummaries.reduce((acc, cur) => acc + cur.amount, 0)
    },

    availableTractTypes () {
      const uniqueTypes = this.balanceSummaries.filter((s, i) => this.balanceSummaries.findIndex(sr => s.tractTypeId === sr.tractTypeId) === i)
        .map(s => ({
          tractTypeId: s.tractTypeId,
          tractTypeName: s.tractTypeName
        }))

      uniqueTypes.unshift({
        tractTypeName: this.$t('allTractTypes')
      })

      return uniqueTypes
    }
  },

  created () {
    this.selectedTractType = this.availableTractTypes[0]
  },

  methods: {
    formatMoney,
    utcToLocalDate,
    ...mapActions('tract', ['fetchObligation']),
    async periodSelected (p) {
      this.selectedPeriod = p
      this.balanceSummaries = await this.fetchObligation(p)
    }
  }
}
</script>
